const mutations = {
    scheduleDetailDataMutation(state, value) {
        state.scheduleDetailDataList = [...value.list];
        state.scheduleDetailProductName = value.productName;
    },
};

export default mutations;